import * as React from "react";
import styleable from "react-styleable";
import { Link } from "react-router-dom";
import * as styles from "../../../css/components/mainlayout/TextWithIcon.css"

/**
 * Regular text with icon on the left.
 * ## styleable
 * * **container** Container styling.
 * * **icon** Icon styling.
 * * **text** Text styling.
 *
 * @property {string} props.text - Text
 * @property {string} props.icon - Icon image location.
 */
class TextWithIcon extends React.Component<any> {
    render() {
        return (
            <div className={this.props.css.container}>
                <img className={this.props.css.icon} src={this.props.icon}/>
                <p className={this.props.css.text}>{this.props.text}</p>
            </div>
        );
    }
}
export default styleable(styles)(TextWithIcon);